import React from 'react';
import { DayPicker } from 'react-day-picker';
import { cn } from '../../lib/utils';

import 'react-day-picker/dist/style.css';

const Calendar = React.forwardRef(
  ({ className, classNames, showOutsideDays = true, ...props }, ref) => {
    return (
      <DayPicker
        ref={ref}
        showOutsideDays={showOutsideDays}
        className={cn('p-2', className)}
        classNames={{
          months:
            'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
          month: 'space-y-4',
          caption: 'flex justify-center pt-1 relative items-center',
          caption_label: 'text-sm font-medium !text-foreground',
          nav: 'flex items-center gap-1 absolute right-2 top-2',
          nav_button:
            'h-7 w-7 bg-transparent !text-foreground p-0 opacity-70 hover:opacity-100 transition',
          table: 'w-full border-collapse space-y-1',
          /** v9: Mo–Su headers use `weekday` (`head_cell` is deprecated and ignored). */
          weekday:
            'rounded-md w-9 font-normal text-[0.8rem] !text-muted-foreground',
          head_row: 'flex',
          head_cell:
            'rounded-md w-9 font-normal text-[0.8rem] !text-muted-foreground',
          row: 'flex w-full mt-2',
          cell:
            'text-center text-sm p-0 relative focus-within:relative focus-within:z-20',
          day: cn(
            'h-9 w-9 p-0 font-normal !text-foreground aria-selected:opacity-100',
            'hover:bg-muted rounded-md transition-colors'
          ),
          day_selected: 'bg-primary !text-primary-foreground',
          day_today: 'bg-accent !text-accent-foreground',
          day_outside: '!text-muted-foreground opacity-50',
          day_disabled: '!text-muted-foreground opacity-50',
          day_range_middle:
            'aria-selected:bg-accent aria-selected:!text-accent-foreground',
          day_hidden: 'invisible',
          ...classNames
        }}
        components={{
          ...props.components
        }}
        {...props}
      />
    );
  }
);

Calendar.displayName = 'Calendar';

export { Calendar };

